const CONFIG = window.__KVITKOVA_TRACKING__ || {};
const IS_LOCAL = CONFIG.environment === "local" || ["localhost", "127.0.0.1"].includes(window.location.hostname);
const IS_PRODUCTION = CONFIG.environment === "production";
let initialized = false;
const queuedLeads = new Set();

export function initializeTracking() {
  if (initialized || !IS_PRODUCTION || readConsent() !== "granted") return;
  initialized = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  if (CONFIG.googleAdsTagId) window.gtag("config", CONFIG.googleAdsTagId, { send_page_view: false });
  if (CONFIG.ga4Id) window.gtag("config", CONFIG.ga4Id, { send_page_view: false });
  if (!CONFIG.googleAdsTagId && !CONFIG.ga4Id) return;
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(CONFIG.googleAdsTagId || CONFIG.ga4Id)}`;
  document.head.append(script);
}

export function track(eventName, parameters = {}) {
  if (!IS_PRODUCTION || readConsent() !== "granted" || typeof window.gtag !== "function") return;
  const payload = { ...parameters };
  if (CONFIG.ga4Id) window.gtag("event", eventName, payload);
  if (eventName === "click_phone" && CONFIG.googleAdsPhoneSendTo) {
    window.gtag("event", "conversion", { send_to: CONFIG.googleAdsPhoneSendTo, value: 1, currency: "UAH" });
  }
}

export function trackOrderRequest(orderNumber) {
  if (!IS_PRODUCTION || readConsent() !== "granted" || typeof window.gtag !== "function" || !orderNumber) return;
  const destinations = [
    [CONFIG.ga4Id, "generate_lead", { lead_id: orderNumber }],
    [CONFIG.googleAdsLeadSendTo, "conversion", { transaction_id: orderNumber }]
  ];
  for (const [destination, eventName, parameters] of destinations) {
    if (!destination) continue;
    const key = `ko-lead:${destination}:${orderNumber}`;
    if (queuedLeads.has(key)) continue;
    try { if (localStorage.getItem(key)) continue; } catch {}
    try {
      window.gtag("event", eventName, { send_to: destination, ...parameters });
      queuedLeads.add(key);
      try { localStorage.setItem(key, "queued"); } catch {}
    } catch {}
  }
}

export function analyticsConsent() {
  return readConsent();
}

export function setAnalyticsConsent(value) {
  if (!IS_LOCAL && ["granted", "denied"].includes(value)) localStorage.setItem("ko-analytics-consent", value);
  if (value === "denied") localStorage.removeItem("ko-attribution-source");
  window.dispatchEvent(new Event("ko-analytics-consent-changed"));
}

function readConsent() {
  try { return localStorage.getItem("ko-analytics-consent") || "unknown"; }
  catch { return "unknown"; }
}

export function ecommerceItem(product, quantity = 1) {
  return {
    item_id: product.id,
    item_name: product.name,
    item_category: product.collection,
    item_variant: product.number,
    price: product.priceCents / 100,
    quantity
  };
}

export function trackItems(eventName, products, quantities = {}) {
  const items = products.map((product) => ecommerceItem(product, quantities[product.id] || 1));
  track(eventName, { currency: "UAH", value: items.reduce((sum, item) => sum + item.price * item.quantity, 0), items });
}

export function attachProductSelectionTracking(documentRef) {
  documentRef.addEventListener("click", (event) => {
    const link = event.target.closest?.(".product-tile a[href^='/products/']");
    if (!link || event.defaultPrevented) return;
    const tile = link.closest(".product-tile[data-product-id]");
    if (!tile) return;
    const product = {
      id: tile.dataset.productId,
      name: tile.dataset.productName,
      collection: tile.dataset.productCollection,
      number: tile.dataset.productNumber,
      priceCents: Number(tile.dataset.productPriceCents)
    };
    trackItems("select_item", [product]);
  });
}

export function isLocalRuntime() {
  return IS_LOCAL;
}
